import { gql, useQuery } from "@apollo/client";
import {
  FindSubscribedAlertUsersQueryQuery,
  FindSubscribedAlertUsersQueryQueryVariables,
} from "../../../../schemaTypes";

export const findSubscribedAlertUsersQuery = gql`
  query FindSubscribedAlertUsersQuery(
    $page: Int!
    $pageSize: Int!
    $searchText: String
  ) {
    findSubscribedAlertUsers(
      page: $page
      pageSize: $pageSize
      searchText: $searchText
    ) {
      data {
        userId
        username
        firstname
        lastname
        isAmbassador
        communityId
        community {
          id
          name
          alias
        }
        location
      }
      total
      page
      pageSize
      totalPages
    }
  }
`;

export function useFindSubscribedAlertUsers(
  variables: FindSubscribedAlertUsersQueryQueryVariables,
) {
  const { data, loading, error, refetch } = useQuery<
    FindSubscribedAlertUsersQueryQuery,
    FindSubscribedAlertUsersQueryQueryVariables
  >(findSubscribedAlertUsersQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  return {
    data: data?.findSubscribedAlertUsers?.data || [],
    meta: data?.findSubscribedAlertUsers,
    loading,
    error,
    refetch,
  };
}
